import React, { useState } from "react";

import axios from "axios";

import { FieldGroup } from "../../components";

const AddressFieldSet = ({ nameObject, isRC, layout, bare, ...props }) => {
  const [country, setCountry] = useState(null);
  const [localityLabel, setLocalityLabel] = useState("City");
  const [postalCodeLabel, setPostalCodeLabel] = useState("Postal code");
  const [regionLabel, setRegionLabel] = useState(null);
  const [regionOptions, setRegionOptions] = useState(null);

  const onCountryChange = async (countryId) => {
    if (country !== countryId) {
      setCountry(countryId);

      const response = await axios.get(
        "/api/countries/" + countryId + "/address-format"
      );
      applyAddressFormat(response.data);
    }
  };

  const applyAddressFormat = (format) => {
    applyPostalCodeFormat(format.fields.postalCode);
    applyLocalityFormat(format.fields.locality);
    applyRegionFormat(format.fields.administrativeArea);
  };

  const applyPostalCodeFormat = (format) => {
    setPostalCodeLabel(
      {
        postal: "Postal code",
        zip: "ZIP",
      }[format?.type] || "Postal code"
    );
  };

  const applyLocalityFormat = (format) => {
    setLocalityLabel(
      {
        city: "City",
      }[format?.type] || "City"
    );
  };

  const applyRegionFormat = (format) => {
    if (!format?.required) {
      setRegionOptions(null);
      setRegionLabel(null);
      return;
    }

    setRegionLabel(
      {
        state: "State",
        region: "Region",
        oblast: "Oblast",
        territory: "Territory",
        province: "Province",
        prefecture: "Prefecture",
      }[format?.type] || "State/Region"
    );

    if (format?.values?.length > 0) {
      setRegionOptions(format.values);
    } else {
      setRegionOptions(null);
    }
  };

  if (layout === "paired") {
    return (
      <>
        <div className="row overview-form__row">
          <div className="col-12">
            <FieldGroup
              noAutofill
              bare={bare}
              placeholder="Country"
              type="country"
              nameObject={nameObject}
              name="country_id"
              onChange={onCountryChange}
              {...props}
              disabled={isRC}
            />
          </div>
        </div>

        <div className="row overview-form__row">
          <div className="col-md-6">
            <FieldGroup
              noAutofill
              bare={bare}
              placeholder="Address"
              nameObject={nameObject}
              name="line1"
              disabled={isRC}
            />
          </div>
          <div className="col-md-6">
            <FieldGroup
              noAutofill
              bare={bare}
              placeholder="Address - line 2"
              nameObject={nameObject}
              name="line2"
              disabled={isRC}
            />
          </div>
        </div>

        {regionLabel !== null ? (
          <>
            <div className="row overview-form__row">
              <div className="col-md-6">
                <FieldGroup
              noAutofill
                  bare={bare}
                  placeholder={regionLabel}
                  nameObject={nameObject}
                  name="region"
                  type={regionOptions ? "select" : "text"}
                  options={regionOptions}
                  disabled={isRC}
                />
              </div>
              <div className="col-md-6">
                <FieldGroup
              noAutofill
                  bare={bare}
                  placeholder={postalCodeLabel}
                  nameObject={nameObject}
                  name="postal_code"
                  disabled={isRC}
                />
              </div>
            </div>
            <div className="row overview-form__row">
              <div className="col-md-6">
                <FieldGroup
              noAutofill
                  bare={bare}
                  placeholder={localityLabel}
                  nameObject={nameObject}
                  name="locality"
                  readOnly={isRC}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="row overview-form__row">
            <div className="col-md-6">
              <FieldGroup
              noAutofill
                bare={bare}
                placeholder={postalCodeLabel}
                nameObject={nameObject}
                name="postal_code"
                disabled={isRC}
              />
            </div>
            <div className="col-md-6">
              <FieldGroup
              noAutofill
                bare={bare}
                placeholder={localityLabel}
                nameObject={nameObject}
                name="locality"
                readOnly={isRC}
              />
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <FieldGroup
              noAutofill
        placeholder="Country"
        type="country"
        nameObject={nameObject}
        name="country_id"
        onChange={onCountryChange}
        {...props}
        disabled={isRC}
      />

      <FieldGroup
              noAutofill
        placeholder="Address"
        nameObject={nameObject}
        name="line1"
        disabled={isRC}
      />

      <FieldGroup
              noAutofill
        placeholder="Address - line 2"
        nameObject={nameObject}
        name="line2"
        disabled={isRC}
      />

      <div className="row">
        {regionLabel !== null && (
          <div className="col-md-6 pr-16">
            <FieldGroup
              noAutofill
              placeholder={regionLabel}
              nameObject={nameObject}
              name="region"
              type={regionOptions ? "select" : "text"}
              options={regionOptions}
              disabled={isRC}
            />
          </div>
        )}

        <div className={"col-md-6 " + (regionLabel === null ? "pr-16" : "")}>
          <FieldGroup
              noAutofill
            placeholder={postalCodeLabel}
            nameObject={nameObject}
            name="postal_code"
            disabled={isRC}
          />
        </div>

        <div className={"col-md-6 " + (regionLabel !== null ? "pr-16" : "")}>
          <FieldGroup
              noAutofill
            placeholder={localityLabel}
            nameObject={nameObject}
            name="locality"
            readOnly={isRC}
          />
        </div>
      </div>
    </>
  );
};

export default AddressFieldSet;
